{
  "itemCooldownMs": 300,
  "crateRespawnMs": 4000,
  "shieldPopInvulnMs": 500,
  "crateSizePx": 32,
  "coinSizePx": 16,
  "boost_jet": { "speedPct": 60, "durationMs": 2000 },
  "shield_bubble": { "durationMs": 8000 },
  "trip_wire": {
    "stunMs": 1200,
    "ownerGraceMs": 1000,
    "lifetimeMs": 20000,
    "dropBehindPx": 48,
    "widthPx": 32,
    "heightPx": 12
  },
  "spike_ball": { "stunMs": 1500, "speedPxPerSec": 600, "lifetimeMs": 4000, "sizePx": 20 },
  "homing_drone": {
    "stunMs": 1500,
    "speedPxPerSec": 540,
    "verticalSpeedPxPerSec": 360,
    "lockPx": 96,
    "lifetimeMs": 6000,
    "sizePx": 20,
    "aimPct": 50
  },
  "oil_slick": {
    "skidMs": 1500,
    "skidSpeedPct": 50,
    "ownerGraceMs": 1000,
    "lifetimeMs": 20000,
    "dropBehindPx": 48,
    "widthPx": 64,
    "heightPx": 8
  },
  "leader_missile": {
    "stunMs": 2000,
    "splashStunMs": 1000,
    "splashRadiusPx": 96,
    "speedPxPerSec": 900,
    "lifetimeMs": 10000,
    "sizePx": 24
  },
  "magnet": { "durationMs": 4000, "radiusPx": 160 },
  "weightsByRank": {
    "1": {
      "boost_jet": 10,
      "shield_bubble": 40,
      "trip_wire": 30,
      "spike_ball": 0,
      "homing_drone": 0,
      "oil_slick": 20,
      "leader_missile": 0,
      "magnet": 10
    },
    "2": {
      "boost_jet": 20,
      "shield_bubble": 25,
      "trip_wire": 20,
      "spike_ball": 15,
      "homing_drone": 5,
      "oil_slick": 15,
      "leader_missile": 0,
      "magnet": 10
    },
    "3": {
      "boost_jet": 25,
      "shield_bubble": 10,
      "trip_wire": 10,
      "spike_ball": 20,
      "homing_drone": 20,
      "oil_slick": 10,
      "leader_missile": 0,
      "magnet": 10
    },
    "4": {
      "boost_jet": 25,
      "shield_bubble": 5,
      "trip_wire": 0,
      "spike_ball": 15,
      "homing_drone": 25,
      "oil_slick": 0,
      "leader_missile": 15,
      "magnet": 5
    }
  }
}
